import IconPao from '../assets/icons/IconPao';

export default {
  IconPao,
};
